import Swal from 'sweetalert2';
import { deletePortofolio } from "../../../api/portofolioAPI";

export const handleDeletePortofolio = async (
  id,
  portofolios,
  setPortofolios
) => {
  const confirmation = await Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  });

  if (!confirmation.isConfirmed) {
    return;
  }

  try {
    Swal.fire({
      title: 'Deleting...',
      text: 'Please wait while we delete the portofolio.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    await deletePortofolio(id);

    setPortofolios(portofolios.filter((portofolio) => portofolio.id !== id));

    Swal.fire({
      icon: 'success',
      title: 'Deleted!',
      text: 'Portofolio has been deleted.',
    });
  } catch (error) {
    console.error("Error deleting portofolio:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to delete portofolio.',
    });
  }
};
